import React,{useState,useEffect} from 'react'
import AppLayout from '../../layout/components/AppLayout'
import RequestPhoneNo from '../components/common/RequestPhoneNo';
import { useAlert } from '../../context/AlertContext';
import portalServices from '../portalServices';
import useSystemMasterList from '../../hooks/useSystemMasterList';
import moment from 'moment';
import { Link } from 'react-router-dom';
import RequestNotificationPermission from '../../notifications/components/RequestNotificationPermission';

function ComplaintListPage() {

	const {AppAlert} = useAlert();
	const [masters,getMasterLabel] = useSystemMasterList(['grievance-type','grievance-status']);
	
	const [complaintList,setComplaintList] = useState(null);


    
    const getComplaintList = (customerPhone) =>{
		if(customerPhone){
			setComplaintList(null);
			portalServices.getComplaintList(customerPhone).then(res=>{
				setComplaintList(res.data);
			}).catch(error=>{
				AppAlert("Somthing went Wrong while loading complaint Try again","error")
			}).finally(()=>{  
			})
		}  
    }


	

	

    return (
        <AppLayout>
			{complaintList &&
				<RequestNotificationPermission />
			}
			<div className='container'>
				<div className='row'>
					{complaintList && complaintList.map(complaint=>
						<div className='col-md-4 col-sm-12' key={complaint.id}>
							<div className='card mb-2'>
								<Link to={"/complaint/details/"+complaint.id} style={{textDecoration:"none"}}>
									{complaint.photo !== null && complaint.photo !== "" &&
										<img src={complaint.photo} className="card-img-top" style={{maxHeight:300}} alt="complaint image" />
									}
									{(complaint.photo === null || complaint.photo == "") &&
										<div className="card-img-top bg-light text-center" style={{height:300}} >
											<h3 className="text-dark p-5"  >No Image Available</h3>
											<button className='btn btn-outline-dark'>View Details</button>
										</div>
									}
								</Link>
								<div className='card-body'>
									<div><span className='fw-bold'>Complaint ID : </span>{complaint.id}</div>
									<div><span className="fw-bold">Complaint About : </span> {getMasterLabel("grievance-type",complaint.grievanceType)}</div>
									<div><p>{complaint.details}</p></div>
									
									<div> 
										<span className="fw-bold">Current Status</span> {getMasterLabel("grievance-status",complaint.grievanceStatus)}
									</div>
									<div>{complaint.address}</div>
									<div className='border p-2 rounded my-2'><span className="fw-bold"> Date : </span>{ moment(complaint.created_at).format("lll")} </div>
									<a target='_blank' href={"https://www.google.com/maps/dir//"+complaint.latitude+", "+complaint.longitude} >Show Direction on Map</a>

									
								</div>
								
								{ complaint.grievanceStatus === 1 &&
									<div className={ 'border border-danger border-2 mb-0'}>
									</div>
								}
								
								{ complaint.grievanceStatus === 2 &&
									<div className={ 'border border-warning border-2 mb-0'}>
									</div>
								}
								{ complaint.grievanceStatus === 3 &&
									<div className={ 'border border-success border-2 mb-0'}>
									</div>
								}

								{ complaint.grievanceStatus === 4 &&
									<div className={ 'border border-danger border-2 mb-0'}>
									</div>
								}



							</div>
						</div>
					)}
				</div>
			</div>
			<RequestPhoneNo requestStatus={true} callback={getComplaintList} canSkip={false} />
        </AppLayout>
    )
}

export default ComplaintListPage